import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_MY_STUDENT_PROFILE_FORM } from '@/graphql/studentProfileForm';
import type { MyStudentProfileFormQuery, MyStudentProfileFormQueryVariables } from '@/types/operations';

/** The signed-in student's own profile form: the fields their school opened to them. */
export function useMyStudentProfileForm(options: { enabled?: Ref<boolean> } = {}) {
  const { result, loading, error, refetch } = useQuery<MyStudentProfileFormQuery, MyStudentProfileFormQueryVariables>(
    GET_MY_STUDENT_PROFILE_FORM,
    {},
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    fields: computed(() => result.value?.myStudentProfileForm.fields ?? []),
    missingRequired: computed(() => result.value?.myStudentProfileForm.missing_required ?? 0),
    loading,
    error,
    refetch,
  };
}
